
import { Component, Vue, Prop, Watch, Inject, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";
// API
import { devicesApi } from '@/services/api.devices.service';
import { cameras } from "@/utils/area-tree/configurations";
// Components
import AreaTreePicker from "@/components/form/AreaTreePicker.vue";
// Types
import { ICamera } from "@/store/views/types";
import { AreaNode } from '@/types/groups/AreaNode';
import { DeviceNode } from '@/types/devices/DeviceNode';
import { AreaTreeNodeType } from '@/types/area-tree/AreaTreeNodeType';
import { AreaContentConfiguration } from '@/types/area-tree/AreaContentConfiguration';

const Mobile = namespace("mobile");

@Component({
	components: {
		"area-tree-picker": AreaTreePicker,
	}
})
export default class MobileCameraSelect extends Vue {
	@Mobile.Mutation setLiveDevice: (camera: ICamera) => void;
	@Mobile.Getter("getLiveDeviceId") liveDeviceId: any;

	private selectedTreeItem: AreaNode | DeviceNode = null;

	@Emit("deviceSelected")
	public deviceSelected() {}

	// Raise event to show camera
	private async showAreaCamera(camera) {
		this.setLiveDevice(camera);
		this.deviceSelected();
	}

	/**
	 * Gets the content configuration to use for the area tree. Sets up cameras to be displayed for groups, and
	 * ensures the search term order feature is passed through.
	 */
	private get treeContentConfiguration(): AreaContentConfiguration[] {
		const searchTermsInAnyOrder = false;
		return [
			{
				...cameras,
				onSearch: async (query, regionUrl) =>
					await devicesApi.searchDevicesForGroupTree(
						query,
						[1],
						searchTermsInAnyOrder,
						regionUrl
					)
			}
		];
	}

	private onTreeItemSelected(treeItem: AreaNode | DeviceNode) {	
		this.selectedTreeItem = treeItem;

		switch (treeItem.nodeType) {
			case AreaTreeNodeType.Group: {
				// Don't do anything yet with a selected groupID
				break;
			}
			case AreaTreeNodeType.Camera: {
				const camera = { deviceID: (treeItem as DeviceNode).deviceId, title: (treeItem as DeviceNode).label }
				this.showAreaCamera(camera);
				break;
			}
			default: {
				console.error("MobileCameraSelect:AreaTreePicker - Unknown item type selected in tree.");
			}
		}
	}
}
